/**
 * ワーカー（synchro-client watch）の起動状態（Issue #733）。ダッシュボードに置く。
 * サーバーの GetWorkers（ClaimExportRequest の生存記録 ＋ processing のジョブ）を 15 秒ごとに読む。
 */
import { useCallback, useEffect, useState } from 'react';
import { api } from '../api/api';

export const POLL_MS = 15000;

const STATE = {
  idle:    { label: '待機中',   color: '#2ecc71' },
  busy:    { label: '処理中',   color: '#3498db' },
  stopped: { label: '止まっている', color: '#888' },
};

export function ageText(sec) {
  if (sec == null) return '—';
  if (sec < 60) return `${Math.round(sec)} 秒前`;
  if (sec < 3600) return `${Math.round(sec / 60)} 分前`;
  if (sec < 86400) return `${Math.round(sec / 3600)} 時間前`;
  return `${Math.round(sec / 86400)} 日前`;
}

export function jobText(job) {
  if (!job) return '';
  const where = job.game_id != null ? `試合 ${job.game_id}` : job.duel_id != null ? `デュエル ${job.duel_id}` : '';
  return `${job.kind}${where ? `（${where}）` : ''}${job.progress ? ` ${job.progress}` : ''}`;
}

export default function WorkersPanel() {
  const [workers, setWorkers] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setWorkers(await api.project('GetWorkers', {}));
      setError(null);
    } catch (e) {
      setError(String(e?.message ?? e));
    }
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, POLL_MS);
    return () => clearInterval(t);
  }, [load]);

  return (
    <div className="card" style={{ marginBottom: 16 }} data-testid="workers-panel">
      <div className="card-title" style={{ marginBottom: 8 }}>ワーカー</div>
      {workers === null ? <div className="card-meta">{error ? `読めません（${error}）` : '読んでいます…'}</div>
        : workers.length === 0 ? <div className="card-meta">この 7 日間に動いたワーカーはありません（synchro-client の watch が ClaimExportRequest を叩くとここに出ます）</div>
        : (
          <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: 14 }}>
            <thead>
              <tr style={{ textAlign: 'left', color: '#a0a0c0' }}>
                <th style={{ padding: '2px 8px 2px 0' }}>状態</th>
                <th style={{ padding: '2px 8px 2px 0' }}>ワーカー</th>
                <th style={{ padding: '2px 8px 2px 0' }}>拾う kind</th>
                <th style={{ padding: '2px 8px 2px 0' }}>最後に見た</th>
                <th style={{ padding: '2px 0' }}>処理中のジョブ</th>
              </tr>
            </thead>
            <tbody>
              {workers.map((w) => {
                const st = STATE[w.state] ?? STATE.stopped;
                return (
                  <tr key={w.worker_id} data-testid="worker-row" data-state={w.state}>
                    <td style={{ padding: '4px 8px 4px 0', whiteSpace: 'nowrap' }}>
                      <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: '50%', backgroundColor: st.color, marginRight: 6 }} />
                      {st.label}
                    </td>
                    <td style={{ padding: '4px 8px 4px 0' }}>
                      {w.worker_id}{w.machine && w.machine !== w.worker_id ? <span className="card-meta">（{w.machine}）</span> : null}
                    </td>
                    <td style={{ padding: '4px 8px 4px 0' }} className="card-meta">{w.kinds ? w.kinds.join(' / ') : '全部'}</td>
                    <td style={{ padding: '4px 8px 4px 0', whiteSpace: 'nowrap' }} title={w.last_seen_at ?? ''}>{ageText(w.age_sec)}</td>
                    <td style={{ padding: '4px 0' }}>{jobText(w.job)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      {error && workers !== null ? <div role="status" style={{ color: '#f99', marginTop: 8 }}>{error}</div> : null}
    </div>
  );
}
